

document.addEventListener('DOMContentLoaded', function() {
  // Funzione che cerca il bottone e cambia il testo
  function changeButtonText() {
    // Selettori multipli per trovare il bottone del popup
    const buttonSelectors = [
      '.vloty-spot-modal .spot-modal-button',
      '.spot-by-vloty-container .spot-button',
      '.spot-modal-wrapper .spot-modal-button',
      'button[data-spot-button]'
    ];
    
    // Prova ciascun selettore
    for (const selector of buttonSelectors) {
      const buttons = document.querySelectorAll(selector);
      
      if (buttons.length > 0) {
        buttons.forEach(button => {
          // Cambia il testo del bottone
          button.textContent = "Scopri di più"; // Sostituisci con il testo desiderato
        });
        console.log('Testo del bottone modificato con successo!');
      }
    }
  }
  
  // Esegui la funzione immediatamente
  changeButtonText();
  
  // Esegui anche dopo un ritardo per catturare bottoni caricati dinamicamente
  setTimeout(changeButtonText, 1000);
  setTimeout(changeButtonText, 2000);
  
  // Osserva cambiamenti nel DOM per catturare popup che vengono aggiunti dinamicamente
  const observer = new MutationObserver(function(mutations) {
    changeButtonText();
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
});